import type { OfflineManifest } from '@floorfile/contracts'
/** D24 owner declaration, consumed by the shared offline runtime. */
export const supplierQualityOfflineManifest: OfflineManifest = {
  module: "supplier_quality",
  entities: [
    "supplier_approval",
    "incoming_inspection",
    "scar",
    "supplier_scorecard",
  ],
  actions: ["draft-incoming-inspection", "capture-inspection-form"],
  conflictPolicy: "server-review-required",
  requiresOnline: [
    "approve-supplier",
    "complete-incoming-inspection",
    "raise-ncr",
    "raise-scar",
    "send-scar",
    "snapshot-scorecard",
  ],
}
